export default {
  loadingFirstMessage: 'Momentje, de designer wordt geladen.',
  checking: 'Checking...',
  cash: 'Verzilveren',
  toLogin: 'Naar inloggen',
  payoff: 'voor als je later groot bent',
  login: 'Log in',
  loginForgot: 'vergeten',
  loginIntro: 'Maak eerst een account aan of log in als je er al één hebt.',
  loginFailed: 'Login mislukt',
  loginNoAccount: 'Ik heb nog geen account',
  loginSendNew: 'Stuur mij een nieuwe login',
  accountCreate: 'Maak account aan',
  accountAlready: ' Al een account? Log hier in',
  voucherPersonalCode: 'Ik heb een persoonlijke code',
  voucherIntro: 'Voer je persoonlijke code in. Je vindt de code achter op je voucher of in de bevestigingse-mail.',
  voucherInvalid: 'Voer een geldige code in van 15 tekens inclusief de koppelstreepjes. Bijvoorbeeld 2Wpa-SFtB-999c.',
  backToLogin: 'Terug naar het login scherm',
  passwordRequest: 'Stuur mij een nieuwe login',
  passwordRequestSend: 'Er is een email verstuurd met verdere instructies.',
  passwordRequestRemember: 'Weet je je wachtwoord weer?',
  childIntro: 'Vul als eerste de naam en geboortedatum van je kind in. Ze worden alvast voor je ingevoegd.',
  menuAccount: 'account',
  menuOrder: 'bestel',
  menuChild: 'kind',
  menuDesigns: 'designs',
  menuPhotos: 'bewerk',
  menuHelp: 'help',
  photosChooseMore: "Kies meer foto's",
  photosChoose: 'Kies je foto’s',
  assignmentSelectPhotosFirst: 'Lees eerst je foto’s in',
  assignmentSelectPhotos: "Lees foto's in",
  assignmentClose: 'Sluit fotorol',
  notificationReady: "Hoera! Je bent klaar. --- Kijk alle tekst en foto's goed na.",
  notificationGoToOrder: 'Naar bestellen',
  orderUnfinishedFirstPart:
    'Je kan nog niet bestellen. Voeg eerst overal de foto’s en tekst toe. Als je nog een geel bolletje ziet dan moet je nog iets toevoegen. Zijn alle bolletjes groen, kijk je werk nog wel even goed na.',
  orderUnfinishedSecondPart: ' Veel plezier!',
  orderIntro: 'Geef je adres op.',

  kidSectionTtitle: 'Kind',
  childBookTargetInput: 'Dit boek is voor:',
  childBookStartButtonOption1: 'Voeg een kind toe',
  childBookStartButtonOption2: 'Voeg nog een kind toe',
  childBookTargetOption1: 'Voor wie ga je het boek maken:',
  childBookTargetOption2: 'Of maak het voor je andere kind:',
  childFormInputNameLabel: 'Roepnaam',
  childFormInputNamePlaceholder: 'Roepnaam van je kind',
  childFormInputLettersInformation: 'Kan niet langer dan 12 karakters zijn',
  childFormInputDateLabel: 'Geboortedatum',
  backButton: 'Terug',
  getStartedButton: 'Aan de slag',

  cameraRollTab: 'fotorol',
  pinupTab: 'prikbord',
  savedPhotosInformation: "Bewaarde foto's om bij andere opdrachten te gebruiken",

  designInformations: 'Probeer de designs maar uit. Je werk gaat niet verloren.',

  photoDoesntUploadAlert: 'Er is 1 foto niet geupload omdat deze te groot is (max 60mb) of niet in het JPG formaat is',
  photoDoesntUploadAlertPlural:
    "Er zijn {rejectedFiles} foto's niet geupload omdat deze te groot zijn (max 60mb) of niet in het JPG formaat zijn",
  callToUseThePhotos: 'Laat los om je foto’s te gebruiken',

  personalGiftCodeLabel: 'Je persoonlijke code',
  cachedVoucherTitle: 'Voucher verzilveren',

  loginCredentialsTitle: 'Log in op je account',
  loginEmailInputLabel: 'E-mailadres',
  loginErrorMessage: 'Je kan niet inloggen met beheerder account',
  loginPasswordInput: 'Wachtwoord',
  forgotPasswordSectionTitle: 'Wachtwoord vergeten',
  forgotPasswordEmailPlaceholder: 'Jouw e-mail adres',
  makeAccountTitleStep1: 'Account aanmaken (1/2)',
  signupFirstNameInputLabel: 'Je eigen voornaam',
  signupFirstNamePlaceholder: 'Voornaam',
  signupEmailInputLabel: 'Je e-mailadres',
  signupPasswordInputLabel: 'Kies een wachtwoord',
  acceptPrivacyStatementFirstPart: 'Ik ga akkoord met de ',
  acceptPrivacyStatementSecondPart: 'algemene voorwaarden en de privacy statement',

  smallScreensMessage1: 'Helaas is Kroost nog niet beschikbaar voor mobiel of kleinere apparaten.',
  smallScreensMessage2: 'Zit je toch op je laptop of desktop? Maak je browser scherm zo groot mogelijk.',

  rotate: 'Roteren',
  mirror: 'Spiegelen',
  zoomIn: 'Inzoomen',
  zoomOut: 'Uitzoomen',

  warningToAdjustPhotoPart1: 'Voor een goede afdrukkwaliteit moet je deze foto aanpassen.',
  warningToAdjustPhotoPart2: 'Wat kan ik doen?',

  logout: 'log uit',
  account: 'Account',
  loading: 'Aan het laden...',
  openNewBook: 'Open een nieuw boek',

  logout2: 'Uitloggen',

  notReadyMessagePart1: 'Voordat je kunt bestellen, moet je',
  notReadyMessagePart2: 'een account aanmaken',
  notReadyMessagePart3: ", zodat wij de foto's kunnen verwerken",
  uploadingPhotosMessage: "Nog niet alle foto's zijn geupload",
  loading2: 'Laden...',
  backToPay: 'terug naar betalen',
  surname: 'Achternaam',
  street: 'Straat',
  houseNumber: 'Huisnummer',
  postCode: 'Postcode',
  city: 'Woonplaats',
  country: 'Land',
  phone: 'Telefoon nummer',
  amount: 'Aantal',
  warningMessageBeforeForNoChanges: 'Je kan deze bestelling niet meer aanpassen',
  fillTheFieldsMessage: 'vul de rode velden om verder te gaan',
  checking2: 'Controleren...',
  orderComplete: 'Bestelling afronden',
  orderTitle: 'Bestellen',

  preferdName: ' Roepnaam',
  dateOfBirth: 'Geboren op (verwacht)',
  makeYourBook: 'Maak jouw boek',

  failedUploadWarning:
    "Er gaat helaas iets mis gegaan bij het uploaden van de foto's. Mocht dit blijven gebeuren, neem dan aub contact met ons op",
  uploandingFaliedMessage: 'Uploaden van {fileName} is mislukt',
  feedbackUploadingMessage: '{fileName} wordt geupload',
  uploadSuccessMessage: '{fileName} is geupload',

  usedPhotoMessageSingular: 'Deze foto wordt op 1 plek gebruikt',
  usedPhotoMessagePlural: 'Deze foto wordt op {count} plekken gebruikt',

  newPasswordLabel: 'Nieuw wachtwoord',
  newPasswordPlaceholder: 'Jouw nieuwe wachtwoord',
  formErrorMessage: ' Reset mislukt, de link is maar 24 uur geldig. Vraag opnieuw aan.',
  passwordButtonSubmit: 'Pas wachtwoord aan',

  saveSuccessTitle: 'Account aanmaken (2/2)',
  enterTheNameOfChildButton: 'Vul de naam in van je kind',
  saveSuccessMessagePart1: 'Je account is aangemaakt. Alle wijzigingen worden automatisch en direct opgeslagen.',
  saveSuccessMessagePart2: 'Veel plezier!',
  netherlands: 'Nederland',
  belgium:'België',
  germany:'Duitsland',
  austria: 'Oostenrijk',
  paymentWaitingMessage:'De betaling is afgebroken of mislukt. Ga terug naar betalen om opnieuw af te rekenenen.',
  paymentFailedMessage: 'De betaling is afgebroken of mislukt. Ga terug naar betalen om opnieuw af te rekenenen.',
  paymentSuccessMessagePart1:'We gaan voor je aan de slag. Check je mail voor de bevestiging. Nog even wachten en dan genieten!',
  greetings: 'Vrolijke groet,',
  teamKroost: 'team Kroost',
  shippingSendMessagePart1: 'Je bestelling is met brievenbuspost verzonden. Je hoeft dus niet thuis te blijven. Nog even wachten en dan kan het genieten beginnen!',
  shippingReceivedMessage:'  Je bestelling is afgeleverd. Geniet ervan!',
  mergingPhotos:"{mergedPhotos} van de {photos} foto's ingelezen",
  doneNotificationMessage:"{mergedPhotos} foto's ingelezen",
  notUsedPhotosMessage:" - {notused} negeert",
  year: 'jaar',
  months: 'maand',
  monthsPlural:"maanden",
  day: "dag",
  days:"dagen",
  week: "week",
  weekPlural:"weken",
  birthday:"Geboortedag!",

};



// WEBPACK FOOTER //
// ./app/languages/nl.js